import { Button, Form } from "antd";
import React, {useState} from "react";
import {CloseCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import Select from "@components/ResponsiveSelect";

export const ScenarioFilters = (props) => {

    const [Facility, setFacility] = useState([]);
    const [Address, setAddress] = useState([]);
    const formRef = React.useRef()

    function handleFacility(Facility) {
        if (Facility?.includes('All')) {
            formRef.current.setFieldsValue({
                Facility: ['All']
            })
        }
        setFacility(Facility)

    }

    const facilityFilter = () => {
        return (
            <Select
                mode="single"
                allowClear
                value={Facility}
                style={{
                    width: '100%',
                }}
                getPopupContainer={trigger => trigger.parentNode}
                placeholder="facility"
                onChange={handleFacility}
                options={props.facility_options}
                dropdownMatchSelectWidth={false}
            />
        )
    }

    function handleAddress(Address) {
        if (Address?.includes('All')) {
            formRef.current.setFieldsValue({
                Address: ['All']
            })
        }
        setAddress(Address)

    }

    const addressFilter = () => {
        return (
            <Select
                mode="single"
                allowClear
                value={Address}
                style={{
                    width: '100%',
                }}
                getPopupContainer={trigger => trigger.parentNode}
                placeholder="address"
                onChange={handleAddress}
                options={props.address_options}
                dropdownMatchSelectWidth={false}
            />
        )
    }

    function handleSubmit(e) {
        console.log('submit', e)
        props.handleFilter(e)
    }

    function handleClearButtonClick() {
        formRef.current.setFieldsValue({
            address: '',
            facility: '',
        })
        props.handleClearButtonClick();
    }

    return <Form
        id="myForm"
        layout="inline"
        onFinish={handleSubmit}
        ref={formRef}
        style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
    >

        <Form.Item name={'Address'} style={{ marginBottom: 0, width: 200 }}>
            {addressFilter()}
        </Form.Item>

        <Form.Item name={'Facility'} style={{ marginBottom: 0, width: 200 }}>
            {facilityFilter()}
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
            <div style={{ display: 'flex', gap: 8 }}>
                <Button type="primary" icon={<QuestionCircleOutlined/>} htmlType="submit">Query</Button>
                <Button icon={<CloseCircleOutlined/>} onClick={handleClearButtonClick}>Clear</Button>
            </div>
        </Form.Item>
    </Form>

}
